import './SquareIndicator.css';

interface SquareIndicatorProps {
  viewBox: number;
  stopOrder: number;
  color: string;
}

const SquareIndicator = ({
  stopOrder,
  viewBox,
  color,
}: SquareIndicatorProps) => (
  <svg
    viewBox={`0 0 ${viewBox} ${viewBox}`}
    width={viewBox}
    height={viewBox}
    className="square-svg"
  >
    <rect
      width={viewBox}
      height={viewBox}
      fill="white"
      stroke={color}
      strokeWidth={5}
    />
    <text
      x={Math.round(viewBox * 0.5)}
      y={Math.round(viewBox * 0.3)}
      dominantBaseline="middle"
      textAnchor="middle"
      transform="translate(0, 6)"
    >
      {stopOrder}
    </text>
  </svg>
);

export default SquareIndicator;
